export default __webpack_public_path__ + "static/media/category2.c8c55318.svg";